import { render, staticRenderFns } from "./UserTag.vue?vue&type=template&id=73c8b4ec&scoped=true"
import script from "./UserTag.vue?vue&type=script&lang=js"
export * from "./UserTag.vue?vue&type=script&lang=js"
import style0 from "./UserTag.vue?vue&type=style&index=0&id=73c8b4ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c8b4ec",
  null
  
)

export default component.exports